import http from '@utils/http'
/**
 * 盲盒活动详情
 */
export function queryBoxPlan(data): Promise<any> {
    return http.post('/sim/queryBoxPlan', data || {})
}
export function queryActivityDetail(data): Promise<any> {
    return http.post('/activity/queryActivityDetail', data || {})
}
export function queryBlindBoxDetail(data): Promise<any> {
    return http.post('/pay/queryBlindBoxDetail', data || {})
}
